var map = {
	"./Logo-HBM-black-256.png": 191,
	"./Logo-HBM-black-512.png": 647,
	"./Logo-HBM-black.png": 9721,
	"./ar-white.png": 4934,
	"./ar.png": 8462,
	"./dimensions.png": 1622,
	"./reset.png": 6901,
	"./screenshot.png": 1501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;